import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03589b0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "sr-only" }, "Buscar", -1))
const _hoisted_2 = { class: "relative w-full" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute right-3 top-2 text-gray-500" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    })
  ])
], -1))




export default /*#__PURE__*/_defineComponent({
  __name: 'SearchForm',
  emits: ['buscar'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const buscar = (e: Event) => {
    emit('buscar', (e.target as HTMLInputElement).value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
    class: "flex items-center"
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        onInput: buscar,
        type: "text",
        placeholder: "Buscar",
        class: "w-72 px-4 py-2 border rounded-lg cursor-text focus:outline-none focus:ring-2 focus:ring-green-500 bg-white"
      }, null, 32),
      _hoisted_3
    ])
  ], 32))
}
}

})